// components/AddLeave/AddLeave.js
import React, { useState } from 'react';
import api from '../../services/api';
import { Input } from '../UI/Input.js';
import { Button } from '../UI/Button.js';
import CustomDatePicker from '../Common/DatePicker';
import styled from 'styled-components';
import { FormContainer, FullWidth } from '../../styles/sharedStyles';


const AddLeave = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [signType, setSignType] = useState('');


  const handleAddLeave = async () => {
  try {
    let url = '/sign/leave';
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate.toLocaleDateString('en-CA'));  //en-CA will provide format YYYY-MM-DD so it is not a fixed timezone
    if (endDate) params.append('end_date', endDate.toLocaleDateString('en-CA'));
	if (signType) params.append('sign_type', signType);
    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    const response = await api.post(url, null);
	alert(response.data.message)
	setStartDate(null);
	setEndDate(null);
	setSignType('')
  } catch (error) {
      console.error('Adding leave failed', error);
      alert('Adding leave failed');
	  }
  };
  
  return (
    <div>
      <h2>Registrar ausencia</h2>
	  <FormContainer>
	  <FullWidth>
  <p style={{ fontSize: '0.9em', color: '#555', marginTop: '-5px', marginBottom: '10px' }}>
    📝 Si solo necesitas registrar una ausencia de un día (por ejemplo, 2025-04-14), selecciona la misma fecha en inicio y fin.
  </p>
</FullWidth>
      <FullWidth>
          <CustomDatePicker selected={startDate} onChange={(date) => setStartDate(date)} placeholder="Selecciona fecha de inicio" isRequired={true} />
       </FullWidth>
	   <FullWidth>
          <CustomDatePicker selected={endDate} onChange={(date) => setEndDate(date)} placeholder="Selecciona fecha de fin"  isRequired={true}/>
       </FullWidth>
	   <FullWidth>
  <select
    value={signType}
    onChange={(e) => setSignType(e.target.value)}
    required
    style={{
      padding: '8px',
      border: '1px solid #ccc',
      borderRadius: '4px'
    }}
  >
    <option value="">Selecciona tipo de ausencia</option>
    <option value="Vacaciones">Vacaciones</option>
    <option value="Baja medica">Baja médica</option>
	<option value="Permiso cuidado de menor">Permiso cuidado de menor</option>
  </select>
</FullWidth>
	  <FullWidth>
      <Button onClick={handleAddLeave}>Registrar</Button>
	  </FullWidth>
	  </FormContainer>
    </div>
  );
};

export default AddLeave;